import type React from "react";
import type { LayoutChangeEvent } from "react-native";
import { type StackProps, YStack } from "tamagui";

export type BoxProps = {
  children?: React.ReactNode;
  noPadding?: boolean;
  onLayout?: (event: LayoutChangeEvent) => void;
} & StackProps;

export const Box: React.FC<BoxProps> = ({
  children,
  onLayout,
  noPadding,
  ...props
}) => {
  return (
    <YStack
      onLayout={onLayout}
      padding={noPadding ? undefined : "$space.larger"}
      backgroundColor={"$backgroundBlock"}
      cursor={props.onPress ? "pointer" : undefined}
      gap={"$large"}
      flex={1}
      {...props}
    >
      {children}
    </YStack>
  );
};
